var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.01 53.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b65ff;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedinRecurso 42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.5,52.51a26,26,0,1,1,26-26A26,26,0,0,1,26.5,52.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.5,1A25.51,25.51,0,1,1,1,26.5,25.51,25.51,0,0,1,26.5,1m0-1A26.51,26.51,0,1,0,53,26.5,26.53,26.53,0,0,0,26.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.53,14.84a3.18,3.18,0,1,1-3.18-3.18A3.17,3.17,0,0,1,20.53,14.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.54,
    y: 20.4,
    width: 5.42,
    height: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.25,28.28V37.9H34.91V29.35c0-2-.09-4.62-2.87-4.62s-3.41,2.2-3.41,4.48V37.9H23.37V20.4h5.26v2.4h0a5.62,5.62,0,0,1,5.13-2.69C39.26,20.11,40.25,23.59,40.25,28.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlue);
export default __webpack_public_path__ + "static/media/linkedin-blue.2fa81d1208a1d1a98fb472e39c7ee75a.svg";
export { ForwardRef as ReactComponent };